import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AnimationUtil } from './animation.util';





@Directive({
    selector: 'dialog'
})
export class DialogDirective implements OnInit, OnDestroy {
    private _dialog?: HTMLDialogElement;

    @Output()
    closingEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    closedEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    openingEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output()
    openedEvent: EventEmitter<void> = new EventEmitter<void>();

    private _observer: MutationObserver;

    @Input()
    @HostBinding('attr.aria-modal')
    modal: boolean;
    @Input()
    canClose: boolean = true;
    @Input()
    disableInert: boolean = false;

    constructor(
        private _elmentRef: ElementRef<HTMLDialogElement>,
    ) {
        this._observer = new MutationObserver((mutations, observer) =>
            mutations.forEach(async mutation => {
                if (mutation.attributeName === 'open')
                    if (!(mutation.target as HTMLDialogElement).hasAttribute('open')) {
                        this._close();
                    } else {
                        this._open();
                    }
            })
        );
    }

    @HostListener('keydown.escape', ['$event'])
    onClose() {
        if (this.canClose)
            this._dialog?.close();
        return false;
    }

    ngOnDestroy(): void {
        if (this._observer != null)
            this._observer.disconnect()
    }

    ngOnInit(): void {
        this._dialog = this._elmentRef.nativeElement;
        this._observer.observe(this._dialog, { attributeFilter: ['open'] });
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        if ((event.target as HTMLElement) === this._dialog && !this._insideOfDialog(event))
            if (this.canClose)
                this._dialog?.close();
    }

    private async _close() {
        if (!this.disableInert)
            this._dialog.setAttribute('inert', '')
        this.closingEvent.emit();
        await AnimationUtil.animationsComplete(this._dialog);
        this.closedEvent.emit();
    }

    private async _open() {
        this._dialog.removeAttribute('inert')
        this.openingEvent.emit();
        await AnimationUtil.animationsComplete(this._dialog);
        this.openedEvent.emit();
        this._setFocus(this._dialog);
    }

    private _setFocus(dialog: HTMLDialogElement) {
        const focusTarget = dialog.querySelector('[autofocus]') as HTMLButtonElement | HTMLInputElement ?? dialog;
        focusTarget.focus();
    }

    private _insideOfDialog(event: MouseEvent): boolean {
        const rect = this._dialog.getBoundingClientRect();
        return (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
            rect.left <= event.clientX && event.clientX <= rect.left + rect.width)
    }
}
